<template>
  <v-card-text> Inject component here.</v-card-text>
</template>

<script setup lang="ts"></script>

<style scoped lang="css"></style>
